import type {CoreEntityType, ListItem} from 'nutshell-core/types';
import type {CloseType} from 'nutshell-core/visual-pipeline/visual-pipeline-types';

// Constant used by React-DnD to match up DropTarget and DropSource
// which must match, and also be unique from other drop types on the page.
export const dragItemTypes = {
    LIST_COLUMN: 'LIST_COLUMN',
    LEAD_CARD: 'LEAD_CARD',
} as const;

type ListColumnDragItem = {
    type: 'LIST_COLUMN';
    item: DndListColumnItem;
};

type LeadCardDragItem = {
    type: 'LEAD_CARD';
    item: DndVisualPipelineLeadCardItem;
};

export type DragItem = ListColumnDragItem | LeadCardDragItem;

/*-----------------
 * Items
 *---------------*/

export type DndListColumnItem = {
    id: string;
    title: string;
    type: CoreEntityType;
    width: number;
};

export type DndVisualPipelineLeadCardItem = {
    id: string;
    stageId: string;
    listItem: ListItem;
    fieldsToDisplay: string[];
};

/*-----------------
 * Drop results
 *---------------*/

// Drop result constants that we use to identify which _type_ of target
// a dragged item was dropped onto. This dictates what type of payload
// to look for when getting the information from the given drop target
export const dropResultTypes = {
    CLOSE_BUTTON: 'CLOSE_BUTTON',
    PIPELINE_COLUMN: 'PIPELINE_COLUMN',
} as const;

export type CloseButtonDropResult = {
    type: 'CLOSE_BUTTON';
    payload: {
        closeType: CloseType;
    };
};

export type PipelineColumnDropResult = {
    type: 'PIPELINE_COLUMN';
    payload: {
        stageId: string;
    };
};

export type LeadCardDropResult = CloseButtonDropResult | PipelineColumnDropResult;
